import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";

export default function Gallery({ isPreview = false, isPage = true }) {
  const navigate = useNavigate();

  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  const API = process.env.PARCEL_API_URL || "http://localhost:5000";

  // 🔥 Detect screen size
  useEffect(() => {
    const checkScreen = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreen();
    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  // 🔥 Fetch images
  useEffect(() => {
    axios
      .get(`${API}/api/gallery`)
      .then((res) => setImages(res.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [API]);

  const wrapperClass = `bg-orange-50 flex flex-col ${
    isPage ? "min-h-screen" : ""
  }`;

  // 🔥 Dynamic skeleton count
  const skeletonCount = isPreview
    ? isMobile
      ? 6 
      : 4 
    : isMobile
      ? 18 
      : 12; 
  return (
    <div className={wrapperClass}>
      <section className="px-4 sm:px-6 md:px-16 lg:px-24 py-12 md:py-16 flex-grow">
        {/* 🔙 Back Button */}
        {isPage && !isPreview && (
          <button
            onClick={() => navigate("/")}
            className="mb-6 text-orange-500 font-semibold hover:underline"
          >
            ← Back to Home
          </button>
        )}

        {/* 🔥 TITLE */}
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8">
          <span className="text-orange-500">Gallery</span>
        </h2>

        {/* 🔥 GRID */}
        <div className="grid gap-3 sm:gap-4 md:gap-6 grid-cols-3 md:grid-cols-3 lg:grid-cols-4">
          {loading ? (
            // 🔥 SKELETONS
            Array(skeletonCount)
              .fill(0)
              .map((_, i) => (
                <div
                  key={i}
                  className="bg-white p-2 sm:p-3 rounded-xl shadow-md"
                >
                  <div className="overflow-hidden rounded-lg">
                    <div className="w-full h-[120px] sm:h-[140px] md:h-[180px] lg:h-[200px] bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-pulse" />
                  </div>
                </div>
              ))
          ) : images.length > 0 ? (
            // 🔥 REAL IMAGES
            (isPreview ? images.slice(0, isMobile ? 6 : 4) : images).map(
              (img, i) => (
                <motion.div
                  key={img._id}
                  whileHover={{ scale: 1.05 }}
                  className="bg-white p-2 sm:p-3 rounded-xl shadow-md w-full cursor-pointer"
                  onClick={() => navigate(`/gallery/view/${img._id}`)}
                >
                  <div className="overflow-hidden rounded-lg">
                    <motion.img
                      src={img.image}
                      initial={{ opacity: 0, scale: 0.8 }}
                      whileInView={{ opacity: 1, scale: 1 }}
                      transition={{ duration: 0.5, delay: i * 0.05 }}
                      className="w-full object-cover h-[120px] sm:h-[140px] md:h-[180px] lg:h-[200px]"
                    />
                  </div>
                </motion.div>
              ),
            )
          ) : (
            <p className="col-span-full text-center text-gray-500">
              No images available
            </p>
          )}
        </div>

        {/* 👉 RIGHT ARROW (HOME ONLY) */}
        {isPreview && (
          <div className="flex justify-end mt-6">
            <button
              onClick={() => navigate("/gallery")}
              className="flex items-center justify-center 
              w-12 h-12 sm:w-14 sm:h-14 rounded-full 
              bg-orange-500 text-white text-2xl sm:text-3xl 
              shadow-lg hover:scale-110 hover:bg-orange-600 transition"
            >
              →
            </button>
          </div>
        )}
      </section>

      {isPage && <Footer />}
    </div>
  );
}
